// Pre-defined museum label look-and-feel variants.
export const MUSEUM_LABEL_THEME_VARS = {
  white: {
    '--museum-label-bg': 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
    '--museum-label-border': 'rgba(148, 163, 184, 0.35)',
    '--museum-label-shadow': '0 16px 34px rgba(148, 163, 184, 0.28)',
    '--museum-label-hover-shadow': '0 20px 38px rgba(148, 163, 184, 0.32)',
    '--museum-label-title': '#0f172a',
    '--museum-label-meta': '#475569',
    '--sheen-opacity': '0.28',
  },
  black: {
    '--museum-label-bg': '#0b0f1a',
    '--museum-label-border': 'rgba(15, 23, 42, 0.85)',
    '--museum-label-shadow': '0 20px 36px rgba(15, 23, 42, 0.6)',
    '--museum-label-hover-shadow': '0 24px 44px rgba(15, 23, 42, 0.65)',
    '--museum-label-title': '#f8fafc',
    '--museum-label-meta': 'rgba(226, 232, 240, 0.85)',
    '--sheen-opacity': '0',
  },
  gold: {
    '--museum-label-bg': 'linear-gradient(138deg, #f8e7b0 0%, #d5a332 52%, #ba7f1c 100%)',
    '--museum-label-border': 'rgba(161, 98, 0, 0.38)',
    '--museum-label-shadow': '0 20px 36px rgba(176, 112, 0, 0.35)',
    '--museum-label-hover-shadow': '0 24px 44px rgba(176, 112, 0, 0.38)',
    '--museum-label-title': '#3b2500',
    '--museum-label-meta': 'rgba(59, 37, 0, 0.78)',
    '--sheen-opacity': '0.22',
  },
};
